<div class="unauthorized401 container-fluid height-full" layout="column" flex-align="center" flex-justify="center">

		<h1 class="margin-top-0">{{ '401_Title' | translate }}</h1>
		<h2 *ngIf="reasonTranslationKey" class="margin-top-0">{{ reasonTranslationKey | translate }}</h2>

</div>